import {Parcel} from './parcels.types.js'

/**
 * Intrapost registers an Envelop as a mail piece (Post Standaard / Post Vast), which has no Track & Trace
 *
 * @param {Pick<Parcel, 'carrier' | 'options'>} parcel
 *
 * @returns {boolean}
 */
function isIntrapostEnvelope(parcel: Pick<Parcel, 'carrier' | 'options'>): boolean {
    return parcel.carrier === 'Intrapost' && !!parcel.options?.includes('Envelop')
}

/**
 * Parcels without Track & Trace have no tracking code or link, no Track & Trace page and no Track & Trace emails
 *
 * @param {Pick<Parcel, 'carrier' | 'options'>} parcel
 *
 * @returns {boolean}
 */
function hasNoTrackTrace(parcel: Pick<Parcel, 'carrier' | 'options'>): boolean {
    return !!parcel.options?.includes('Brievenbuspakket zonder Track & Trace') || isIntrapostEnvelope(parcel)
}

export {isIntrapostEnvelope, hasNoTrackTrace}
